import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    visibility: 1,
    drawer: false,
    loadingRoute: false,
    mobile: false,
    path: null,
    user: null,
    token: null,
    manualGeneralAdminWhitelabel: null,
    eventSelected: null,
    loadingDomain: false,
    domain: null,
    coupon: null,
  },
  mutations: {
    setLoadingDomain: (state, data) => {
      state.loadingDomain = data;
    },
    setDomain: (state, data) => {
      state.domain = data;
    },
    setCoupon: (state, data) => {
      state.coupon = data;
    },
    setVisibility: (state, data) => {
      state.visibility = data;
    },
    setUser: (state, data) => {
      state.user = data;
    },
    setToken: (state, data) => {
      state.token = data;
    },
    setCardActive: (state, data) => {
      state.card_active = data;
    },
    setNextCard: (state, data) => {
      state.next_card = data;
    },
    setEventSelected: (state, data) => {
      state.eventSelected = data;
    },
    setDrawer: (state, data) => {
      state.drawer = data;
    },
    setLoadingRoute: (state, bool) => {
      state.loadingRoute = bool;
    },
    setMobile: (state, bool) => {
      state.mobile = bool;
    },
    setPath: (state, data) => {
      state.path = data;
    },
    setManualGeneralAdminWhitelabel: (state, data) => {
      state.manualGeneralAdminWhitelabel = data;
    },
  },
});
